import React from "react";

import MenuEditorGeneral from "../_menuEditor/menuEditor";

const MenuCreate = ({ dishes, isDishesLoading, handleCreateNewMenu }) => {
  const initialMenu = {
    name: "",
    description: "",
    purposeType: "print",
    websitePurpose: "",
    dishes: [],
    menuDate: new Date(Date.now()).toISOString().slice(0, 10)
  };

  const handleSetToDefault = (setterCallback) => {
    setterCallback({ ...initialMenu });
  };

  const handleCreateSaveMenu = async (menu, setterCallback) => {
    await handleCreateNewMenu(menu);

    handleSetToDefault(setterCallback);
  };

  return (
    <div className="subSection">
      <h3 className="subSection__heading">CREATE NEW MENU</h3>
      <MenuEditorGeneral
        menu={initialMenu}
        dishes={dishes}
        handleSaveMenu={handleCreateSaveMenu}
        handleCancel={handleSetToDefault}
      />
    </div>
  );
};

export default MenuCreate;
